import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const tableHeaderStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
  fontWeight: 'bold',
  backgroundColor: '#b15cd6',
  color: 'white',
};

const tableCellStyle = {
  border: '1px solid #ddd',
  textAlign: 'center',
};

const enterButtonStyle = {
  padding: '6px 12px',
  backgroundColor: '#b15cd6',
  border: 'none',
  borderRadius: '4px',
  color: 'white',
  cursor: 'pointer',
};

const paidButtonStyle = {
  padding: '6px 12px',
  backgroundColor: '#4caf50',
  border: 'none',
  borderRadius: '4px',
  color: 'white',
  cursor: 'not-allowed',
};

const Grocerycashbilling = () => {
  const [vendorId, setVendorId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [cashBillingData, setCashBillingData] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [paidInput, setPaidInput] = useState('');
  const [notesCount, setNotesCount] = useState({});
  const navigate = useNavigate();
  const [token, setToken] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const formatCurrency = (value) => {
    const num = parseFloat(value ?? 0);
    if (isNaN(num)) return "0.00";
    try {
      return num.toFixed(2);
    } catch {
      return "0.00";
    }
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Load vendorId & token from localStorage
  useEffect(() => {
    const storedVendorId = localStorage.getItem('vendorId');
    const storedToken = localStorage.getItem('authToken');
    setVendorId(storedVendorId);
    setToken(storedToken);
  }, []);

  // Fetch accepted orders
  useEffect(() => {
    if (!vendorId) return;

    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("Missing authentication token. Please log in again.");
      return;
    }

    const fetchOrders = async () => {
      try {
        const response = await axios.get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const acceptedOrders = response.data.filter(
          (order) => order.orderStatus === 'PROCESSING'
        );
        setOrders(acceptedOrders);
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };

    fetchOrders();
  }, [vendorId]);

  // Fetch billing data for all orders
  const fetchBillingData = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("Authentication token is missing. Please log in again.");
      return;
    }

    const newData = {};
    for (const order of orders) {
      try {
        const response = await axios.get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/get/${order.orderId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        newData[order.orderId] = response.data;
      } catch (error) {
        console.error(
          "Error fetching billing data for order",
          order.orderId,
          error.response?.data || error.message
        );
      }
    }

    setCashBillingData(newData);
  };

  useEffect(() => {
    if (orders.length > 0) {
      fetchBillingData();
    }
  }, [orders]);

  const handleNotesChange = (denomination, count) => {
    if (count === '' || /^[0-9\b]+$/.test(count)) {
      setNotesCount((prev) => ({
        ...prev,
        [denomination]: count,
      }));
    }
  };

  const handleEnterPayment = (orderId) => {
    const order = orders.find((o) => o.orderId === orderId);
    setSelectedOrder(order);
    setPaidInput('');
    setNotesCount({});
    setShowPopup(true);
  };

  const handlePaymentSubmit = async () => {
    if (!selectedOrder) {
      alert('No order selected.');
      return;
    }

    const orderId = selectedOrder.orderId;
    const paidAmount = parseFloat(paidInput);
    const grandTotal = parseFloat(selectedOrder?.grandTotal ?? 0);

    if (isNaN(paidAmount) || paidAmount <= 0) {
      alert('Please enter a valid paid amount.');
      return;
    }

    const returnMoney = parseFloat((paidAmount - grandTotal).toFixed(2));

    const data = {
      id: 0,
      orderId,
      oneRupee: parseInt(notesCount[1] || 0),
      twoRupee: parseInt(notesCount[2] || 0),
      fiveRupee: parseInt(notesCount[5] || 0),
      tenRupee: parseInt(notesCount[10] || 0),
      twentyRupee: parseInt(notesCount[20] || 0),
      fiftyRupee: parseInt(notesCount[50] || 0),
      hundredRupee: parseInt(notesCount[100] || 0),
      twoHundredRupee: parseInt(notesCount[200] || 0),
      fiveHundredRupee: parseInt(notesCount[500] || 0),
      twoThousandRupee: 0,
      grandTotal: grandTotal,
      paid: paidAmount,
      returnMoney: returnMoney >= 0 ? returnMoney : 0,
    };

    try {
      const token = localStorage.getItem("authToken");
      const vendorId = localStorage.getItem("vendorId");

      const response = await axios.post(
        `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/addCash/${orderId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      alert('CASH payment submitted successfully!');
      setShowPopup(false);

      localStorage.setItem("showPaymentData", "true");
      localStorage.setItem("selectedService", selectedOrder.service || "Dine In");
      localStorage.setItem("orderData", JSON.stringify(selectedOrder));
      localStorage.setItem("paymentData", JSON.stringify(data));
      localStorage.setItem("vendorId", vendorId);

      navigate("/grocerycart");
      fetchBillingData();
    } catch (error) {
      console.error('❌ CASH Payment submission error:', error);
      alert('Failed to submit CASH payment.');
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "-15px" }}>
        <thead>
          <tr>
            <th style={tableHeaderStyle}>S.No</th>
            <th style={tableHeaderStyle}>OrderId</th>
            <th style={tableHeaderStyle}>Total</th>
            <th style={tableHeaderStyle}>Paid</th>
            <th style={tableHeaderStyle}>Return</th>
            <th style={tableHeaderStyle}>₹1</th>
            <th style={tableHeaderStyle}>₹2</th>
            <th style={tableHeaderStyle}>₹5</th>
            <th style={tableHeaderStyle}>₹10</th>
            <th style={tableHeaderStyle}>₹20</th>
            <th style={tableHeaderStyle}>₹50</th>
            <th style={tableHeaderStyle}>₹100</th>
            <th style={tableHeaderStyle}>₹200</th>
            <th style={tableHeaderStyle}>₹500</th>
            <th style={tableHeaderStyle}>Action</th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 && (
            <tr>
              <td style={tableCellStyle} colSpan={15}>No accepted orders found.</td>
            </tr>
          )}

          {orders.map((order, index) => {
            const billing = cashBillingData[order.orderId] || {};
            return (
              <tr key={order.orderId}>
                <td style={tableCellStyle}>{index + 1}</td>
                <td style={tableCellStyle}>{order.orderId}</td>
                <td style={tableCellStyle}>₹{formatCurrency(order?.total)}</td>
                <td style={tableCellStyle}>₹{formatCurrency(billing?.paid)}</td>
                <td style={tableCellStyle}>₹{formatCurrency(billing?.returnMoney)}</td>
                <td style={tableCellStyle}>{billing.oneRupee || 0}</td>
                <td style={tableCellStyle}>{billing.twoRupee || 0}</td>
                <td style={tableCellStyle}>{billing.fiveRupee || 0}</td>
                <td style={tableCellStyle}>{billing.tenRupee || 0}</td>
                <td style={tableCellStyle}>{billing.twentyRupee || 0}</td>
                <td style={tableCellStyle}>{billing.fiftyRupee || 0}</td>
                <td style={tableCellStyle}>{billing.hundredRupee || 0}</td>
                <td style={tableCellStyle}>{billing.twoHundredRupee || 0}</td>
                <td style={tableCellStyle}>{billing.fiveHundredRupee || 0}</td>
                <td style={tableCellStyle}>
                  {billing.paid ? (
                    <button style={paidButtonStyle} disabled>Paid</button>
                  ) : (
                    <button
                      style={enterButtonStyle}
                      onClick={() => handleEnterPayment(order.orderId)}
                    >
                      Enter Payment
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Payment Popup */}
      {showPopup && selectedOrder && (
        <div
          style={{
            position: 'fixed',
            top: 0, left: 0, width: '100vw', height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            zIndex: 1000, padding: '20px', overflow: 'auto'
          }}
        >
          <div
            style={{
              backgroundColor: '#fff', padding: '24px', borderRadius: '10px',
              width: '90%', maxWidth: '450px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.3)', fontFamily: 'sans-serif'
            }}
          >
            <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>
              Enter Payment for Order: <span style={{ color: '#444' }}>{selectedOrder.orderId}</span>
            </h3>

            <div style={{ marginBottom: '16px', fontSize: '16px' }}>
              <label>
                Grand Total: <strong>₹{formatCurrency(selectedOrder?.total)}</strong>
              </label>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontSize: '14px' }}>Paid Amount</label>
              <input
                type="number"
                value={paidInput}
                onChange={(e) => setPaidInput(e.target.value)}
                placeholder="Enter paid amount"
                style={{
                  width: '100%', padding: '8px', borderRadius: '6px',
                  border: '1px solid #ccc', fontSize: '14px'
                }}
              />
            </div>

            <div
              style={{
                marginBottom: '20px', backgroundColor: '#f9f9f9',
                padding: '16px', borderRadius: '8px', border: '1px solid #eee'
              }}
            >
              <h4 style={{ marginBottom: '12px', fontSize: '16px' }}>Denomination Breakdown</h4>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: screenWidth < 768 ? "1fr" : "repeat(3, 1fr)",
                  gap: '10px 16px',
                }}
              >
                {[1, 2, 5, 10, 20, 50, 100, 200, 500].map((denom) => (
                  <div key={denom} style={{ display: 'flex', alignItems: 'center', fontWeight: "bold" }}>
                    <label style={{ width: '50px', fontSize: '16px' }}>₹{denom}</label>
                    <input
                      type="number"
                      value={notesCount[denom] || ''}
                      onChange={(e) => handleNotesChange(denom, e.target.value)}
                      placeholder="0"
                      style={{
                        width: '60px', padding: '6px', borderRadius: '4px',
                        border: '1px solid #ccc', fontSize: '14px'
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
              <button
                style={{
                  flex: 1, padding: '10px', backgroundColor: '#4caf50',
                  border: 'none', borderRadius: '6px', color: 'white',
                  fontWeight: 'bold', cursor: 'pointer',
                }}
                onClick={handlePaymentSubmit}
              >
                Submit
              </button>
              <button
                style={{
                  flex: 1, padding: '10px', backgroundColor: '#f44336',
                  border: 'none', borderRadius: '6px', color: 'white',
                  fontWeight: 'bold', cursor: 'pointer',
                }}
                onClick={() => setShowPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Grocerycashbilling;
